import React from 'react';
import { connect } from 'react-redux';

import { Store } from '../../store/reducers/reducers';
import FetchState from '../../utils/FetchState';
import { Props as CircularProgressProps } from './CircularProgress';
import FetchStateCircularProgress from './FetchStateCircularProgress';

interface OwnProps {
  className?: string;
  selectors: ((store: Store) => FetchState | undefined)[];
  children?: React.ReactNode;
  circularProgressProps?: Partial<CircularProgressProps>;
  showOnNotFound?: () => JSX.Element;
}

interface StateProps {
  fetchStates: (FetchState | undefined)[];
}

interface Props extends OwnProps, StateProps {}

function FetchStateCircularProgressContainer(props: Props) {
  const { selectors, ...others } = props;
  return <FetchStateCircularProgress {...others} />;
}

const mapStateToProps = (store: Store, ownProps: OwnProps): StateProps => ({
  fetchStates: ownProps.selectors.map((selector) => selector(store)),
});

const actions = {};

export default connect<StateProps, object, OwnProps>(mapStateToProps, actions)(FetchStateCircularProgressContainer);
